import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
import { clientQuery } from 'Core/data/GraphQLApi';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    data: null,
    reviewEvent: null,
    error: false
};


const route = "accounts/views/components/edgeTensorVideoReview/redux/slice";

export const edgeTensorVideoReviewSave = createAsyncThunk("accounts/views/components/edgeTensorVideoReview/redux/slice/edgeTensorVideoReviewSave", async (payload, { rejectWithValue, dispatch }) => {

    try {
        const { rowId, deviceId, companyId, fieldName, jsonValue, visibleToDriver } = payload;
        let QUERY = `
            mutation createDeviceReadingExtraField ($rowId: String! $deviceId: String! $companyId: String! $fieldName: String! $jsonValue: String! $visibleToDriver: Boolean) {
                result: createDeviceReadingExtraField (rowId: $rowId, deviceId: $deviceId, companyId: $companyId, fieldName: $fieldName, jsonValue: $jsonValue, visibleToDriver: $visibleToDriver) {
                    id
                    readingId
                    fieldName
                    jsonValue
                    visibleToDriver
                }
            }
        `;

        let data = await clientMutation(
            QUERY,
            {
                rowId,
                deviceId,
                companyId,
                fieldName,
                jsonValue,
                visibleToDriver
            },
            endpoints.GRAPHQL_GENERAL
        );

        return data?.result;

    } catch (exc) {
        // ALWAYS RETURN ACTION
        ExceptionManager(exc, route, 'edgeTensorVideoReviewSave');
        return rejectWithValue(exc);
    }
}
)

export const edgeTensorVideoReviewGetEvent = createAsyncThunk("accounts/views/components/edgeTensorVideoReview/redux/slice/edgeTensorVideoReviewGetEvent", async (payload, { rejectWithValue, dispatch }) => {

    try {
        let result = null;
        const { rowId } = payload;
        let QUERY = `
            query searchAiVideoReviews ($conditions: [AiVideoReviewSearchInput], $sort: [AiVideoReviewSortInput], $limit: Int, $offset: Int) {
                    result: searchAiVideoReviews (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            unitId
                            deviceId
                            rowId
                            accountId
                            unitTime
                            eventResult
                            eventName
                            status
                            resultEventNames
                            urlsOverview
                            deviceReading {
                                eventName
                                videoReview
                                deviceData
                            }
                            createdOn
                            updatedOn
                        }
                    }
                }
        `;

        let data = await clientQuery(
            QUERY,
            {
                conditions: [{ fields: "rowId", terms: [rowId], exact: true }],
                sort: [],
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL
        );

        if (data?.result) {
            result = _.cloneDeep(data.result);
            if (result?.items?.[0]?.deviceReading?.deviceData) {
                result.items[0].deviceReading.deviceData = JSON.parse(JSON.parse(result.items[0].deviceReading.deviceData));
            }
            if (result?.items?.[0]?.deviceReading?.videoReview) {
                result.items[0].deviceReading.videoReview = JSON.parse(result.items[0].deviceReading.videoReview);
            }
            if (result?.items?.[0]?.urlsOverview) {
                result.items[0].urlsOverview = JSON.parse(result.items[0].urlsOverview);
                if (!Array.isArray(result.items[0].urlsOverview))
                    result.items[0].urlsOverview = JSON.parse(result.items[0].urlsOverview)

            }
        }

        return result?.items?.[0] || null;

    } catch (exc) {
        // ALWAYS RETURN ACTION
        ExceptionManager(exc, route, 'edgeTensorVideoReviewGetEvent');
        return rejectWithValue(exc);
    }
})

export const edgeTensorVideoReviewRedux = createSlice({
    name: 'accounts/views/components/edgeTensorVideoReviewSave',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalEdgeTensorVideoReview(state, action) {
            state.openModal = true
            state.data = action.payload.data
        }

    },
    extraReducers: (builder) => {
        builder.addCase(edgeTensorVideoReviewSave.pending, (state, action) => {
            state.loading = true
        });

        builder.addCase(edgeTensorVideoReviewSave.fulfilled, (state, action) => {
            state.result = action.payload
            state.loading = false;
        });

        builder.addCase(edgeTensorVideoReviewSave.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });
        builder.addCase(edgeTensorVideoReviewGetEvent.pending, (state, action) => {
            state.loading = true
        });

        builder.addCase(edgeTensorVideoReviewGetEvent.fulfilled, (state, action) => {
            state.reviewEvent = action.payload
            state.loading = false;
        });

        builder.addCase(edgeTensorVideoReviewGetEvent.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        });
    }
})

const { actions, reducer } = edgeTensorVideoReviewRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalEdgeTensorVideoReview
} = actions;

export default reducer;
